// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrganizationalAffiliation  {
    _originalTypeClassName = "Loom.BO.OrganizationalAffiliation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrganizationalAffiliation.translate = translateService;
}
this.AffiliatedOrganisations = [];
this.Id = null;
this.CreatedOn = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
CreatedOn:any;
Description:any;
AffiliatedOrganisations:any;
CreatedBy:any;
static setAffiliatedOrganisations = ($this, items) => {
                if (items == null) items = [];
                if ($this.AffiliatedOrganisations == null) $this.AffiliatedOrganisations = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AffiliatedOrganisations.length > 0) {
                    Domain.OrganizationalAffiliation.removeAffiliatedOrganisations($this, $this.AffiliatedOrganisations[0]);
                }

                Domain.OrganizationalAffiliation.addManyAffiliatedOrganisations($this, copyItems);
            }
static addManyAffiliatedOrganisations = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OrganizationalAffiliation.addAffiliatedOrganisations($this, items[i]);
                }
            }
static addAffiliatedOrganisations = ($this, item) => {
                if ($this.AffiliatedOrganisations == null) $this.AffiliatedOrganisations = [];
                if (item == null || $this.AffiliatedOrganisations.indexOf(item) > -1) return;
                $this.AffiliatedOrganisations.push(item);
Domain.Organisation.addParticipatedAffiliations(item, $this);
}
static addRangeAffiliatedOrganisations = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OrganizationalAffiliation.addAffiliatedOrganisations($this, item));
            }
static removeAffiliatedOrganisations = ($this, item) => {
                if ($this == null || $this.AffiliatedOrganisations == null || $this.AffiliatedOrganisations.indexOf(item) === -1) return;
                var _index = $this.AffiliatedOrganisations.indexOf(item);
                $this.AffiliatedOrganisations.splice(_index, 1);
Domain.Organisation.removeParticipatedAffiliations(item, $this);
}
static clearAffiliatedOrganisations = ($this) => { $this.AffiliatedOrganisations = null; }
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}